// Module dependencies
const scriptLoader = () => import(/* webpackChunkName: "ScriptCommon" */ 'app/common/lib/Script');

/** @const */
const gapi = {
  /**
   * @param {function(!GAPI)} callback
   */
  get(callback) {
    const GPLUS_SCRIPT_ID = 'gplus';

    scriptLoader().then(({ default: script }) => {
      script.load([], 'https://apis.google.com/js/client:platform.js', GPLUS_SCRIPT_ID);
      script.ready(GPLUS_SCRIPT_ID, () => {
        callback(window.gapi);
      });
    });
  },
};

export default gapi;
